export enum MarketBillStatus  {
    New = 0,
    Paid = 1,
    Canceled = 2,
    Used = 3,
    Undefined = 4
}